<template>
    <div class="ObjectMapPage">
        <ObjectListHeaderPanel/>
        <div class="ObjectMapPage__content">
            <yandex-map
                    class="ObjectMapPage__map"
                    :coords="coordsCenter"
                    :zoom="zoom"
                    :controls="['zoomControl']"
                    :cluster-callbacks="{1: {click: clickCluster}}"
                    :cluster-options="clusterOptions"
            >

                <ymap-marker
                    :marker-id="obj.id"
                    :coords="obj.cords"
                    v-for="obj in objects"
                    :key="obj.id"
                    cluster-name="1"
                />

            </yandex-map>
            <div class="ObjectMapPage__object-list" v-if="filteredObjects.length">
                <!--<ObjectsPreviewList @close="selectedIds = []" :objects="filteredObjects" name="Дома в поселке Жуковка-2" location="Рублёво-Успенское ш., Иславское"/>-->
                <ObjectsPreviewList @close="selectedIds = []" :objects="filteredObjects"/>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
import Footer from "@/components/Footer";
import ObjectsPreviewList from "@/components/Object/ObjectsPreviewList";
import ObjectListHeaderPanel from "@/components/ObjectListHeaderPanel";
import {mapGetters} from "vuex";

export default {
    name: "ObjectMapPagePage",
    components: {
        ObjectListHeaderPanel,
        Footer,
        ObjectsPreviewList,
    },
    data: () => ({
        zoom: 10,
        clusterOptions: {
            "1": {
                clusterDisableClickZoom: true,
                clusterOpenBalloonOnClick: false
            },
        },
        selectedIds: []
    }),
    computed: {
        filteredObjects() {
            return this.objects.filter(({id}) => this.selectedIds.includes(id));
        },
        coordsCenter() {
            let count = 0;
            const coordsSum = this.objects.reduce(([sumX, sumY], {cords: [x, y]}) => {
                if (x && y) {
                    count++;
                    return [sumX + +x, sumY + +y];
                }
                return [sumX, sumY];
            }, [0, 0]);
            return coordsSum.map(coord => coord / count);
        },
        ...mapGetters({objects: 'filteredAndSortingObjects'})
    },
    methods: {
        clickCluster(e) {
            const target = e.get('target');
            if (target.properties.get('markerId')) {
                this.openList([target.properties.get('markerId')]);
            } else {
                const ids = target.getGeoObjects().map(obj => obj.properties.get('markerId'));
                this.openList(ids);
            }
        },
        openList(ids) {
            this.selectedIds = ids;
        }
    }
}
</script>

<style lang="scss">
.ObjectMapPage {
  padding-top: 30px;//130px;

    @include tablet {
        padding-top: 50px;
    }

  &__content {
    position: relative;
    display: flex;
    height: 660px;
    width: 100%;
  }

  &__map {
    height: 100%;
    width: 100%;
    font-size: 32px;

    background-color: $grayLight;
  }

  &__object-list {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    flex-shrink: 0;
    width: 310px;
    height: 100%;
    background-color: $white;
  }
}
</style>